<mat-sidenav-container style="height:100%;">
  <mat-sidenav #sidenav mat-component-id="sidenav" [opened]="true" mode="side">
    <mat-nav-list>
      <a mat-list-item routerLinkActive="active">Feature Management</a>
    </mat-nav-list>
  </mat-sidenav>

  <section class="container shadow-container">
    <div class="width100 grey-header">
      <div class="grey-header-text user-groups-header pull-left">
        User Groups
      </div>
      <div class="grey-header-text pull-left">
        Group Features
      </div>
      <div class="grey-header-text pull-left">
        Tenant Groups
      </div>
    </div>

    <div class="content">
      <div class="group-left">
        <div class="overflowAuto">
          <ul data-qa-id="feature-management-list-user-groups">
            @for (userGroup of groups; track userGroup) {
              <li [ngClass]="{'selected': isUserGroupSelected(userGroup)}">
                <button type="button" (click)="open(userGroup)">
                  {{userGroup?.Name}}
                </button>
              </li>
            }
          </ul>
        </div>

        <a data-qa-id="feature-management-btn-add-group" class="addGroupButton" (click)="showAddGroup()">
          <h2>+ Add Group</h2>
        </a>
        @if (show) {
          <button type="button" data-qa-id="feature-management-btn-close-add-group" class="cancelAddGroup" (click)="hideAddGroup()">
            <h2>- Close Add Group</h2>
          </button>
        }
      </div>

      <div class="group-right">
        @if (!selectedUserGroup) {
          <div>
            <p>Please select a group.</p>
          </div>
        }
        @if (selectedUserGroup) {
          <ng-container class="width100">
            <div class="group-right-top">
              <div class="details-line">
                <div class="bold-text"> {{selectedUserGroup?.Name}} </div>
                <mat-icon data-qa-id="feature-management-btn-delete-group" class="delete-icon" tabindex="0" role="button" (click)="deleteGroup(selectedUserGroup)" (keydown.enter)="deleteGroup(selectedUserGroup)" (keydown.space)="deleteGroup(selectedUserGroup); $event.preventDefault()">delete</mat-icon>
              </div>
              <div class="details-line">
                <div class="bold-text">Auth ID</div>
                <div style="font-weight: 500;font-size: small">{{selectedUserGroup.Id}}</div>
              </div>
            </div>
            <div class="tables">
              <div class="table">
                <div class="headings">
                  <h1 class="namePosition">Name</h1>
                  <h1 class="pull-right activePosition">Active</h1>
                </div>
                <div class="scrollable-features">
                  @for (groupFeature of selectedGroupFeatures; track groupFeature) {
                    <div class="featureName">
                      <p class="namePosition">{{groupFeature.FeatureName}}</p>
                      <mat-slide-toggle class="checkPosition pull-right"
                        [disabled]="isDisabledToggle(groupFeature)"
                        [(ngModel)]="groupFeature.HasPermission"
                        color="accent"
                      (change)="toggleFeatureForGroup(groupFeature)"></mat-slide-toggle>
                    </div>
                  }
                </div>
              </div>
              <div class="table">
                <div class="headings">
                  <h1 class="namePosition">Name</h1>
                  <h1 class="pull-right activePosition">Active</h1>
                </div>
                <div class="scrollable-features">
                  @for (tenantGroup of selectedTenantGroups; track tenantGroup) {
                    <div class="featureName">
                      <p class="namePosition">{{ getTenantGroupName(tenantGroup.tenantGroupName) }}</p>
                      <mat-slide-toggle class="checkPosition pull-right"
                        [disabled]="isDisabledTenantGroup(tenantGroup)"
                        [(ngModel)]="tenantGroup.hasPermission"
                        color="accent"
                        (change)="toggleTenantGroupForGroup(tenantGroup)">
                      </mat-slide-toggle>
                    </div>
                  }
                </div>
              </div>
            </div>
          </ng-container>
        }
      </div>
    </div>
  </section>

  @if (show) {
    <section class="shadow-container width080">
      <div class="width100 grey-header">
        <h1 class="width025 pull-left addGroupTitle">Add Group</h1>
      </div>
      <div class="groupDetails">
        <form (ngSubmit)="onSubmit()">
          <p class="pull-left">Name:</p>
          <input data-qa-id="feature-management-input-group-name" class="pull-left" type="text" [(ngModel)]="newGroup.Name" name="groupName" required/>
          <p class="pull-left">Guid:</p>
          <input data-qa-id="feature-management-input-group-guid" class="pull-left" type="text" [(ngModel)]="newGroup.Id" name="permissionGuid" required/>
          <input data-qa-id="feature-management-btn-submit-group" class="pull-left mat-accent mat-raised-button" type="submit" value="Submit">
        </form>
      </div>
    </section>
  }
</mat-sidenav-container>
